import { Box, Card, Grid, Typography } from "@mui/material";
import type { MsmeAuthMarketingPanelProps } from "../types";
import {
  MSME_FEATURE_GRID_THEMES,
  msmeGridFeatureDescriptionSx,
  msmeGridFeatureIconBoxSx,
  msmeGridFeatureTitleSx,
  renderMsmeFeatureIcon,
} from "../msmeFeatureThemes";

const OndcGridPanel: React.FC<MsmeAuthMarketingPanelProps> = ({
  content,
  subheadline,
  networkBadgeSrc,
}) => {
  const { features } = content;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box sx={{ width: 404, maxWidth: "100%", mb: "8px" }}>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "24px",
            textAlign: "center",
            mb: "2px",
          }}
        >
          Grow Your Business Faster by Selling on
          <Box
            component="img"
            src={networkBadgeSrc}
            alt="ONDC"
            sx={{
              width: { xs: 60, sm: 80, md: 100 },
              objectFit: "contain",
              height: 22,
              verticalAlign: "middle",
              mb: "2px",
              ml: 0.5,
            }}
          />
        </Typography>

        {subheadline ? (
          <Typography
            gutterBottom
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              py: 1,
              textAlign: "center",
              color: "rgba(0, 0, 0, 0.4)",
            }}
          >
            {subheadline}
          </Typography>
        ) : null}
      </Box>

      <Grid container spacing={1.5} sx={{ maxWidth: 500, mx: "auto", width: "100%" }}>
        {features.map((item) => {
          const theme = MSME_FEATURE_GRID_THEMES[item.colorScheme];

          return (
            <Grid item xs={12} sm={6} key={item.title} sx={{ display: "flex" }}>
              <Card
                sx={{
                  background: theme.bg,
                  border: `1px solid ${theme.border}`,
                  borderRadius: "14px",
                  p: { xs: 1.5, sm: 2 },
                  width: "100%",
                  height: "100%",
                  minHeight: { sm: 148 },
                  boxShadow: `0 8px 24px -8px ${theme.glow}, 0 2px 8px rgba(15, 23, 42, 0.04)`,
                  transition: "box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease",
                  "&:hover": {
                    boxShadow: `0 14px 32px -10px ${theme.glow}, 0 6px 16px rgba(15, 23, 42, 0.08)`,
                    transform: "translateY(-3px)",
                    borderColor: theme.accent,
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.25,
                    height: "100%",
                  }}
                >
                  <Box
                    sx={{
                      ...msmeGridFeatureIconBoxSx,
                      border: `1px solid ${theme.border}`,
                    }}
                  >
                    {renderMsmeFeatureIcon(item.icon, theme.iconColor, 22)}
                  </Box>
                  <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography sx={msmeGridFeatureTitleSx}>{item.title}</Typography>
                    <Typography sx={{ ...msmeGridFeatureDescriptionSx, mt: 0.5 }}>
                      {item.description}
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default OndcGridPanel;
